// extracted by mini-css-extract-plugin
export var header = "_gs-0";